import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxSuppliers from "../../util/remote/ajaxSuppliers"; // <-- ADD THIS
const RegisterSupplierModal = (props) => {
  const [loading, setLoading] = useState(false);
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));

  const [stationID, setStationID] = useState(station_idd);
  const [stations_company_id, setStations_company_id] = useState("");
  // Supplier form fields
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [alt_contact, setAltContact] = useState("");
  const [address, setAddress] = useState("");
  // Get station mother company
  const fetchStationMotherCompany = async () => {
    setLoading(true);
    const data = { station_id: stationID };
    const response = await ajaxStations.get_station_mother_company_id(data);
    if (response.status === "OK") {
      setStations_company_id(response.details);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchStationMotherCompany();
  }, [stationID]);
  // Validate
  const allRowsFilled = () => name && contact && address && stations_company_id;
  // Submit Supplier
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const data = {
      stations_company_id,
      name,
      contact,
      alt_contact,
      address,
    };
    setLoading(true);
    const response = await ajaxSuppliers.create_supplier(data);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      props.func();
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setName("");
    setContact("");
    setAltContact("");
    setAddress("");
  };
  // Fetch stations for display
  const [stations_list, setStationsList] = useState([]);
  const fetchStations = async () => {
    setLoading(true);
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((s) => ({
          value: Number(s.id),
          label: s.station_name,
        }));
      setStationsList(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchStations();
  }, []);
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={handleAdd}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Register Supplier"}
      </button>
    </>
  );
  return (
    <SystemModal title="Create Supplier" size="md" footer={RenderFooter}>
      <Toaster />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Supplier Information</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Station (disabled) */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Station <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={stations_list}
                        value={
                          stations_list.find(
                            (s) => s.value === Number(stationID)
                          ) || null
                        }
                        isDisabled={true}
                      />
                    </div>
                    {/* Supplier Name */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Supplier Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="form-control"
                        placeholder="Enter supplier name"
                      />
                    </div>
                    {/* Contact */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Contact Phone <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                        className="form-control"
                        placeholder="Contact number"
                      />
                    </div>
                    {/* Alternate Contact */}
                    <div className="col-md-12 mb-3">
                      <label>Alternate Contact</label>
                      <input
                        type="text"
                        value={alt_contact}
                        onChange={(e) => setAltContact(e.target.value)}
                        className="form-control"
                        placeholder="Optional alternate number"
                      />
                    </div>
                    {/* Address */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Address <span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        className="form-control"
                        rows={3}
                        placeholder="Supplier physical address"
                      ></textarea>
                    </div>
                    {/* Hidden company ID */}
                    <input type="hidden" value={stations_company_id} />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default RegisterSupplierModal;
